module.exports = __webpack_public_path__ + "assets/img/e498304272f6b6c9304391499f149cf5.svg";